export default __webpack_public_path__ + "static/media/151-online-store.26efedac.png";